export const canImportPluginFolder = false;
export function legacyPlugins() { return []; }
export function markLegacyPluginsSynced() {}
export async function importPluginFolder() { throw new Error('Import plugin folders from Gab AI for Mac. Installed skills sync to your account.'); }
